import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const SectionList = styled.ul`
  margin: 0;
  padding: 0;
`

const Section = styled.li`
  cursor: pointer;
  display: inline-block;
  font-size: 15px;

  &.active {
    color: ${props => props.theme.link.colorHover};
  }

  &:not(.active):hover {
    color: ${props => props.theme.link.colorHover};
    text-decoration: underline;
  }
  &:not(:last-child) {
    padding-right: 10px;
  }
`

class SectionsMenu extends Component {
  renderSection (section) {
    const {
      activeSection,
      onSectionClick
    } = this.props

    const isActive = section === activeSection

    return (
      <Section key={section} className={ isActive ? 'active' : ''} onClick={() => onSectionClick(section)}>
        { section }
      </Section>
    )
  }

  render () {
    const {
      sections
    } = this.props

    return (
      <SectionList>
        { sections.map(section => this.renderSection(section)) }
      </SectionList>
    )
  }
}

SectionsMenu.propTypes = {
  activeSection: PropTypes.string.isRequired,
  onSectionClick: PropTypes.func.isRequired,
  sections: PropTypes.array.isRequired
}

export default SectionsMenu
